import React, { ChangeEvent, Component } from 'react';
import { RootState } from '../../../redux/store';
import { changeConnection, changeConnectionIsUpdate, clearConnection } from '../../../redux/actions/ConnectionActions';
import { enterComponent, leaveComponent } from '../../../redux/actions/ComponentActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import RoleHelper from '../../../RoleHelper';
import FormicaInput from '../../custom/FormicaInput';
import FormicaLabel from '../../custom/FormicaLabel';
import ComponentName from '../../../constant/ComponentName';
import LanguageUtil from '../../../util/LanguageUtil';

class ConnectionNoSqlComponent extends Component<Props> {
  public render() {
    const {
      connection: { connection },
    } = this.props;
    return (
      <div className={'flex w-full h-full mt-2 border-t-[0.5px] border-b-[0.5px] border-[#E0E4E8] '}>
        <div className={'flex flex-col w-full h-full px-10 py-10'}>
          <form className={'flex flex-col gap-y-4 w-1/2'}>
            <section>
              <FormicaLabel label={LanguageUtil.get({ id: 'pages.connection.nosql.database', defaultMessage: 'Database Name' })} />
              <FormicaInput
                id={'databaseName'}
                value={connection.databaseName}
                disabled={!RoleHelper.canEdit('Connection')}
                onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeConnection(e)}
                label={'Database'}
                placeholder={LanguageUtil.get({ id: 'common.input.placeholder.database', defaultMessage: 'Database' })}
                data-testid={`${ComponentName.CONNECTION}_database_input`}
              />
            </section>
            <section>
              <FormicaLabel label={LanguageUtil.get({ id: 'pages.connection.nosql.collection', defaultMessage: 'Collection Name' })} />
              <FormicaInput
                id='connectionString'
                value={connection.connectionString}
                disabled={!RoleHelper.canEdit('Connection')}
                onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeConnection(e)}
                label={LanguageUtil.get({ id: 'common.label.collection', defaultMessage: 'Collection String' })}
                placeholder={LanguageUtil.get({ id: 'common.input.placeholder.collection', defaultMessage: 'Collection String' })}
                data-testid={`${ComponentName.CONNECTION}_connection_string_input`}
              />
            </section>
            {/*
            <AnimatedButton
              disabled={!RoleHelper.canEdit("Connection")}
              onClick={(e) => e.preventDefault()} className={"self-end"} customType={"primary"} icon={"deploy"} text={"Test"}/>

            */}
          </form>
        </div>
      </div>
    );
  }

  private onChangeConnection = (e: ChangeEvent<HTMLInputElement>) => {
    const {
      changeConnection,
      connection: { connection },
    } = this.props;
    connection[e.currentTarget.id] = e.target.value;
    changeConnection(connection);
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  connection: state.connection,
  isUpdate: state.connection.isUpdate,
});
const mapDispatchToProps = { changeConnectionIsUpdate, changeConnection, clearConnection, enterComponent, leaveComponent };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ConnectionNoSqlComponent);
